import QueryFieldKey from '@opsbase/lib-data-queryfield/QueryFieldKey';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useOps from '@opsbase/react-gql-hooks/op/useOps';
import useCss from '@opsbase/web-css';
import ZoomIcon from '@opsbase/web-icons/icons/ZoomIcon';
import Card from '@opsbase/web-layout/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import Dots from '@opsbase/web-ui/Dots';
import IconButton from '@opsbase/web-ui/IconButton';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
import OpViewOverview from '../../op/OpViewOverview';
import { makeSectionClasses } from '../OpDefinitionEditOverviewTab';
export function LatestPerfOverviewSection(props) {
    const { opDefinition, opCountLoading, opCount, className } = props;
    const { goTo } = useNav();
    const myCss = useCss(makeSectionClasses);
    const { loading, data } = useOps({
        variables: {
            opDefinition: [opDefinition.id],
            sortBy: QueryFieldKey.OP_ACTUALCOMPLETE,
            sortByDesc: true,
            limit: 1,
        },
        skip: opCountLoading || !opCount,
    });
    const op = data === null || data === void 0 ? void 0 : data[0];
    const handleOpen = useCallback(() => {
        if (!op)
            return;
        goTo(Pages.OP_VIEW, { id: op.id });
    }, [goTo, op]);
    return (React.createElement(Card, { classes: { root: className } },
        React.createElement(Vertical, { gutter: true },
            React.createElement(Horizontal, { shrink: true },
                React.createElement(Pane, { grow: true },
                    React.createElement(Text, { variant: "h2" }, i18n.t('latest-result'))),
                !!op && (React.createElement(Pane, null,
                    React.createElement(IconButton, { size: 24, icon: React.createElement(ZoomIcon, { color: Palette.GreyBlue, size: 18 }), classes: { root: myCss.openButton + ' dragcancel' }, tooltip: i18n.t('view-data'), tooltipDelay: 100, onClick: handleOpen })))),
            React.createElement(Pane, { grow: true },
                (loading || opCountLoading) && (React.createElement(Dots, { style: { margin: 'auto' }, color: Palette.LavendarGrey })),
                !opCountLoading && !opCount && (React.createElement(Text, { centered: true, variant: "h2", color: "grey" }, i18n.t('no-data-until-performed'))),
                !loading && !!opCount && !!op && React.createElement(OpViewOverview, { op: op })))));
}
export default LatestPerfOverviewSection;
